<template>
  <!-- 投资人意愿评价 -->
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button type="primary" size="small" @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-style="{ borderColor: '#dcdfe6' }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 关键决策人员姓名 -->
      <el-table-column
        prop="decisionName"
        label="关键决策人员姓名"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'decisionName' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.decisionName"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.decisionName }}
          </div>
        </template>
      </el-table-column>
      <!-- 职位 -->
      <el-table-column
        prop="position"
        label="职位"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'position' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.position"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.position }}
          </div>
        </template>
      </el-table-column>
      <!-- 对我司业务事项 -->
      <el-table-column
        prop="divisionBusinessMatters"
        label="对我司业务事项"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'divisionBusinessMatters' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.divisionBusinessMatters"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.divisionBusinessMatters }}
          </div>
        </template>
      </el-table-column>
      <!-- 态度或意愿描述 -->
      <el-table-column
        prop="attitudeDescription"
        label="态度或意愿描述"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'attitudeDescription' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.attitudeDescription"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.attitudeDescription }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateInvestorEvaluationApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [], // 表格数据
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        decisionName: "", // 关键决策人员姓名
        position: "", // 职位
        divisionBusinessMatters: "", // 对我司业务事项
        attitudeDescription: "", // 态度或意愿描述
        remark: "" // 备注
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateInvestorEvaluationApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data || [];
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
  ::v-deep {
    .disabled_column {
      background: #f2f2f2 !important;
    }
    .total_column,
    .el-table__footer-wrapper tbody td.el-table__cell {
      background: #c0cfde !important;
    }
  }
}
</style>
